import { render, staticRenderFns } from "./EvaluationCriteriaMacro.vue?vue&type=template&id=6489d196&scoped=true"
import script from "./EvaluationCriteriaMacro.vue?vue&type=script&lang=js"
export * from "./EvaluationCriteriaMacro.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCriteriaMacro.vue?vue&type=style&index=0&id=6489d196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489d196",
  null
  
)

export default component.exports